<div id="account-expired" class="lg-form-container" fxLayout="column" ngcPerfectScrollbar>

    <div id="account-expired-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="account-expired-form" class="lg-form">

            <div class="logo" alt="logo"></div>

            <div class="title">
                Account Expired
            </div>

            <div class="subtitle">
                Your {{environment.customer?.appTitle}} account has expired. As a result, your access to {{environment.customer?.appTitle}} has been deactivated.<br/>
                <br/>If you would like to reactivate your account and restore your access, please contact <a href="mailto:support@gg4l.com">support@gg4l.com</a>
            </div>

        </div>

    </div>

    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>

</div>
